<template>
  <div id="myaccount">
      <stock-header></stock-header>
    <div class="market_wrapper">
      <div class="top_bar">
      </div>
      <div class="market_content">
        <ul class="market_right">
          <li style="text-align:center;background: #f0f0f0a8;width: 205px;font-size: 18px;">
            <span>香港股市</span>
          </li>

          <li @click="changeAccount(1)" style="text-align:left;padding-left: 14px;margin-left: 9px;" :class="$store.state.accountType ==1 ? 'market_li_active' : '' ">
            <router-link to="/stockmarket/allhkstock">全部港股</router-link>
          </li>
          <li @click="changeAccount(2)" style="text-align:left;padding-left: 14px;margin-left: 9px;" :class="$store.state.accountType ==2 ? 'market_li_active' : '' ">
            <router-link to="/stockmarket/popularhkstock">热门港股</router-link>
          </li>
          <li @click="changeAccount(3)" style="text-align:left;padding-left: 14px;margin-left: 9px;" :class="$store.state.accountType ==3 ? 'market_li_active' : '' ">
            <router-link to="/stockmarket/hkstocksgains">港股涨幅</router-link>
          </li>
          <li @click="changeAccount(4)" style="text-align:left;padding-left: 14px;margin-left: 9px;" :class="$store.state.accountType ==4 ? 'market_li_active' : '' ">
            <router-link to="/stockmarket/hkstocksdecline">港股跌幅</router-link>
          </li>
          <li @click="changeAccount(5)" style="text-align:left;padding-left: 14px;margin-left: 9px;" :class="$store.state.accountType ==5 ? 'market_li_active' : '' ">
            <router-link to="/stockmarket/hkstockturnover">港股成交额</router-link>
          </li>
          <li @click="changeAccount(6)" style="text-align:left;padding-left: 14px;margin-left: 9px;" :class="$store.state.accountType ==6 ? 'market_li_active' : '' ">
            <router-link to="/stockmarket/hkstocktradingvolume">港股成交量</router-link>
          </li>
          
        </ul>
          <router-view name="kids"></router-view>
      </div>
    </div>
    <keep-alive>
    </keep-alive>
  </div>
</template>
<script>
import "./../assets/css/account.css";
import "./../assets/css/deal.css";
import StockHeader from "@/components/stockheader";
export default {
  name: "Stockmarket",
  data(){
    return{
    }
  },
  components: {
      StockHeader,
    },
  mounted() {
  },
  methods: {
    isLogin(){
      if (!this.$store.state.loginType){
        this.$router.push({
          path: "/login"
        });
      }
    },
    changeAccount(type) {
      window.sessionStorage.setItem("accountType", type);
      this.$store.state.accountType = type;
    },
  }
};
</script>
<style scoped>
@import url("./../assets/css/account.css");
@import url("./../assets/css/deal.css");
*{
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}
  .header_wrapper{
    height: 100px;
    width: 100%;
    background-color: #e35353;
    margin-bottom: 10px;
  }
  .header_info{
    min-width: 1000px;
    max-width: 1200px;
    margin: 0 auto;
    height: 100%;
  }
  .portrait{
    margin-top: 10px;
  }
  .header_right{
    color: white;
    height: 100px;
  }
  .line{
    display: block;
    width: 100%;
    height: 1px;
    background: url(../assets/img/line.png) no-repeat;
  }
  .center-nickname{
    font-size: 18px;
    padding-bottom: 10px;
  }
  .last-time{
    padding-top: 10px;
    font-size: 14px;
  }
  .content-flex{
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .top_bar{
    margin-bottom: 10px;
  }

  .market_wrapper {
  width: 100%;
  overflow: hidden;
  margin-bottom: 0;
}

.market_content {
  width: 1203px;
  /*height: 540px;*/
  background: #fff;
  margin: 0 auto 0;
  overflow: hidden;
}

.market_right {
  display: inline-block;
  width: 185px;
  margin: 0;
}

.market_li_active{
  background-color: unset !important;
}

.market_right > li {
  width: 100%;
  box-sizing: border-box;
  font-size: 16px;
  line-height: 45px;
  padding: 0;
  /*text-indent: 56px;*/
  text-align: center;
}

.market_right > li > a {
  color: #333;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/stockmarket.vue